export default "__VITE_ASSET__D61nynR3__"